import { createBrowserHistory } from "history";

/**
 * Our own history, used to programatically control
 * our routing while we transition out of class components.
 * Eventually, we should try to rely on React Router's useHistory
 * or <Redirect push /> and <Links />
 */
export const history = createBrowserHistory()
